import { ICollection, IGif, INiche, INicheFeedbackResponse, TAddFeedback } from "@/common/api/services/types";

export interface IAddToNichePopupProps {
  gifId: string;
  tags: string[];
  preferences?: string[];
}

export interface IReportPopupProps {
  gifId: string;
}

export interface IAddToCollectionPopupProps {
  gifId: string;
  boosted: boolean;
  position?: number;
  playCount?: number;
}
export interface ICreateNewCollectionPopupProps {
  onCreated: (collection: ICollection) => void;
}

export interface IEditNichePopupContainerProps {
  niche: INiche;
}

export enum Roles {
  admin = "admin",
  moderator = "moderator",
  owner = "owner",
}

export interface IEditNichesDialogProps {
  gifId: string;
  role: Roles;
}

export interface IGifPreferencePopupProps {
  sexuality: string[];
  gifId?: string;
}

export interface IShareGifMenuProps {
  gif: IGif;
  anchorEl: HTMLElement | null;
  position?: number;
  playCount?: number;
}

export interface IMoreMenuContainerProps {
  gif: IGif;
  position: number;
  anchorEl: HTMLElement | null;
  playCount: number;
  hideGif: (id: string) => void;
  onOpenTagFeedbackMode?: () => void;
  addNicheFeedback?: TAddFeedback;
  nicheFeedbacks?: INicheFeedbackResponse[];
}

export interface INicheMoreMenuContainerProps {
  niche: INiche;
  anchorEl: HTMLElement;
}

export enum ScrollSectionEnum {
  MANAGE_LINKS = "MANAGE_LINKS",
}

export interface IEditGifPopupProps {
  gif: IGif;
  scrollToSection?: ScrollSectionEnum;
  getUserGifs?: () => void;
}

export interface IAddDescriptionPopup {
  onPublish: () => void;
  onAddDescription: () => void;
}

export interface IAddToNicheConfirm {
  onContinue: () => void;
}

export interface IGifNichesPopup {
  niches: INiche[];
}

export interface IProfileOptions {
  username: string;
}
